import { Pipe, PipeTransform } from '@angular/core';

import { TranslationKey } from '../consts/translation-key.type';
import { t, TranslationParams } from '../services/translate';

/**
 * Impure on purpose. A pure pipe memoises on its arguments, and a cid never changes — so the
 * view would keep rendering the bundled Dutch after the async overlay lands. Guarded by
 * translate-pipe.spec.ts; making this pure again turns every translation into a silent no-op.
 */
@Pipe({
  name: 'translate',
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  public transform(cid: TranslationKey, params?: TranslationParams): string {
    return t(cid, params);
  }
}
